import React, {useState, useEffect, useMemo} from 'react';
import Table from '../ui/Table.js';
import ModifyForm from './modify.js';
import Box from '../ui/Box.js';
import moment from 'moment';

import {callback, usePrevious, parseRaspberryRowText} from '../../helpers.js';
import api from '../../api/index.js';

export default (props) => {
	const [selected, setSelected] = useState(false);
	const [interfaceOpen, setInterfaceOpen] = useState(false);

	const columns = React.useMemo(() => [
		{
			Header: 'Day',
			accessor: 'Date',
		},
		{
			Header: 'Task',
			accessor: (r, ri) => {
				if (r.hasOwnProperty('split') && r.split == true) {
					if (r.hasOwnProperty('overtime') && r.overtime == true)
						return <><em>⤷ {r.TaskName}</em> <small>(overtime)</small></>;
					else
						return <>{r.TaskName} <small>(regular time)</small></>;
				}
				return <>{r.TaskName}</>;
			}
		},
		{
			Header: 'Where',
			accessor: (r, ri) => { return r.FarmName === null ? 'Not specified.' : r.FarmName + (r.FieldNumber !== null ? ': Field ' + r.FieldNumber : '')},
		},
		{
			Header: 'Hours',
			accessor: 'Hours',
			// accessor: (r, ri) => {
				// return <input onClick={(e)=>{e.preventDefault(); e.stopPropagation();}}value={r.Hours}/>;
			// }
		},
		{
			Header: 'Rate',
			accessor: (r, ri) => { 
				//console.log(r, ri);
				if (r.RateTypeID == 4) { // Raspberry piece rate
					//console.log(parseFloat(r.TaskAmount));
					let base = parseFloat(r.TaskAmount);
					let calculated = r.value;
					if (calculated > base)
						return <><s>${parseFloat((base || 0)).moneyFormat()}</s> ${parseFloat((calculated || 0)).moneyFormat()}</>; 
					else
						return '$' + parseFloat((r.value || 0)).moneyFormat(); 
				} else {
					if (r.hasOwnProperty('overtime') && r.overtime == true)
						return <strong title="Overtime">${parseFloat(r.Rate).moneyFormat()}/hr</strong>; 
					return '$' + parseFloat(r.Rate).moneyFormat() + '/hr' 
				}
			}
		}
	],[]);

	const editOne = (d) => {
		//console.log("edit one", d, props.payperiods);
		for(let i=0; i < props.payperiods[0].tasks.length; i++) {
			if (props.payperiods[0].tasks[i]['AttendanceID'] === d['AttendanceID']) {
				// If it's a split task, use the underlying hours instead of the first split hours we find
				let t = props.payperiods[0].tasks[i];
				if (t.hasOwnProperty('underlying_hours'))
					t['Hours'] = t['underlying_hours'];
				setSelected(t);
				setInterfaceOpen(true);
				break;
			}
		}
	}


	const closeInterface = (e) => {
		setInterfaceOpen(false);
	}

	const onUpdated = (e) => {
		closeInterface();
		props.onUpdated();
	}
/*
	const breakdown = () => {
		let byRateType = {};
		let weekData = [
			{
				totalHours: 0,
				regularHours: 0,
				regularAccrued: 0,
				overtimeHours: 0,
				overtimeAccrued: 0,
			},
			{
				totalHours: 0,
				regularHours: 0,
				regularAccrued: 0,
				overtimeHours: 0,
				overtimeAccrued: 0,
			}
		]

		let ot = (props.overtime.length > 0)  ?  parseFloat(props.overtime[0].NumberOfHours) : false;

		for(let i=0; i < props.Records.length; i++) {
			let week = Math.floor((moment(props.Records[i].Date).diff(moment(props.startDate), "days"))/7);
			//console.log(props.Records[i].Date, "minus", props.startDate, "is week", week, " : days", moment(props.Records[i].Date).diff(moment(props.startDate), "days"));

			// Split hours for each entry into if they're overtime hours or not
			let hours = parseFloat(props.Records[i].Hours);

			let rh = hours; // Regular hours for this entry
			let oth = 0; // Overtime hours for this entry
			let rate = parseFloat(props.rates.employees[props.Employee.EmployeeID][props.Records[i].Date].Rate);

			if (ot !== false && weekData[week].totalHours + hours >= ot) {
				oth = (weekData[week].regularHours + hours) - ot;
				rh = hours - oth;
			}


			if (!byRateType.hasOwnProperty(props.Records[i].Task.RateTypeID)) {
				byRateType[props.Records[i].Task.RateTypeID] = {
					'hours': 0,
					'amount': 0,
					'wageAccrued': 0
				};
			}
			byRateType[props.Records[i].Task.RateTypeID].hours += parseFloat(props.Records[i].Hours);
			byRateType[props.Records[i].Task.RateTypeID].amount += parseFloat(props.Records[i].Task.data.amount);
			byRateType[props.Records[i].Task.RateTypeID].wageAccrued += rh*rate + oth*rate*1.5; // Overtime is 1.5x the rate


			if (props.Records[i].Task.RateTypeID == 5) continue; // Don't count sick hours toward totals

			weekData[week].totalHours += hours;
			weekData[week].regularHours += rh;
			weekData[week].overtimeHours += oth;
			weekData[week].regularAccrued += rh*rate;
			weekData[week].overtimeAccrued += oth*rate*1.5; // Overtime is 1.5x the rate
		}

		let output = [];
		for(let type in byRateType) {
			let data = byRateType[type];
			let typedata = props.ratetypes[type][0];
			if (typedata['Units'] == 'Hours') {
				output.push(<li key={type}><small>At {typedata['RateTypeName']} Rate: {data['hours']} hours (${data['wageAccrued']})</small></li>);
			} else {
				output.push(<li key={type}><small>{typedata['RateTypeName']} Rate: {data['hours']} hours and {data['amount']} {typedata['Units']} (${data['wageAccrued']} by hours)</small></li>);
			}
		}

		const sickHours = byRateType.hasOwnProperty(5) ? byRateType[5]['hours'] : 0;
		const sickHoursAccrued = byRateType.hasOwnProperty(5) ? byRateType[5]['wageAccrued'] : 0;

		output = [<ul key="breakdown">{output}</ul>];
		output.push(<p key="regular-summary">Regular hours: {weekData[0].regularHours +  weekData[1].regularHours} (${(weekData[0].regularAccrued + weekData[1].regularAccrued).moneyFormat()})</p>);
		output.push(<p key="overtime-summary">Overtime hours: {weekData[0].overtimeHours + weekData[1].overtimeHours} (${(weekData[0].overtimeAccrued + weekData[1].overtimeAccrued).moneyFormat()})</p>);
		output.push(<p key="sick-summary">Sick hours: {sickHours} (${sickHoursAccrued.moneyFormat()})</p>);
		output.push(<p key="total-summary"><strong>Total hours: {weekData[0].totalHours + weekData[1].totalHours + sickHours} (${(weekData[0].regularAccrued + weekData[1].regularAccrued + weekData[0].overtimeAccrued + weekData[1].overtimeAccrued + sickHoursAccrued).moneyFormat()})</strong></p>);

		// Figure out minimum wage amount (including overtime)
		// *** TODO i dont actually need this yet because we're not really taking piece rates into account
		return output;
	}
*/
	//console.log(props);
	
	// breakdown
	const breakdown = () => {
		let output = [];
		
		const calculations = props.payperiods[0].calculations;
		for(let i=0; i < calculations.weeks.length; i++) {
			const week = calculations.weeks[i];
			let wo = [];
			
			let rate = <>${week.PieceRateHourlyRate.moneyFormat()}</>;
			if (week.PieceRateHourlyRate != week.PieceRateBaseHourlyRate)
				rate = <><s>${week.PieceRateBaseHourlyRate.moneyFormat()}</s> {rate}</>;
			wo.push(<tr key={"week-" + i + "piece-rate-hourly-rate"}><td>Piece rate hourly</td><td>{rate}</td></tr>);
			wo.push(<tr key={"week-" + i + "piece-rate-hours"}><td>Piece rate hours</td><td>{week.PieceRateHours}</td></tr>);
			wo.push(<tr key={"week-" + i + "break-hours"}><td>Break hours ({week.Breaks} breaks)</td><td>{week.BreakHours} (${(week.BreakHours*week.PieceRateHourlyRate).moneyFormat()})</td></tr>);
			wo.push(<tr key={"week-" + i + "gross-from-rows"}><td>Gross pay from rows</td><td>${week.GrossPayFromRows.moneyFormat()}</td></tr>);
			output.push(<table className="sheet" key={"week-" + i + "table"}><thead><tr><th colSpan="2">Week {i+1}</th></tr></thead><tbody>{wo}</tbody></table>);
		}
		output = <div className="weeks" key="weeks-holder">{output}</div>;
		

		// table or list of row values (1 row at 90, 4 rows at 50, etc.)
		const rowvals = {};
		for(let i=0; i < props.payperiods[0].tasks.length; i++) {
			const task = props.payperiods[0].tasks[i];
			if (task['RateTypeID'] == 4) { // Raspberry piece rate
				const parsed = parseRaspberryRowText(task.data.text || '');
				for(let t=0; t < parsed['data'].length; t++) {
					if (rowvals.hasOwnProperty(parsed['data'][t][1])) {
						rowvals[parsed['data'][t][1]] += parseFloat(parsed['data'][t][0]);
					} else {
						rowvals[parsed['data'][t][1]] = parseFloat(parsed['data'][t][0]);
					}
				}
			}
		}
		
		let rows = [];
		for(let prop in rowvals) {
			rows.push(<li key={prop}>{rowvals[prop]} row{rowvals[prop] == 1 ? '' : 's'} at ${parseFloat(prop).moneyFormat()}</li>);
		}
	
		let total = [];
		// gross pay from rows (piecerate; no top up; no break)
		total.push(<tr key={"total-gross-from-rows"}><td>Gross pay from rows</td><td>${calculations.total.GrossPayFromRows.moneyFormat()}</td></tr>);

		if (rows.length > 0) {
			rows = <ul key="rowlist">{rows}</ul>;
			total.push(<tr key="total-row-list" className="rowlist"><td colSpan="2">{rows}</td></tr>);
		}
		
		// total piece rate hours
		total.push(<tr key={"total-piece-rate-hours"}><td>Piece rate hours</td><td>{calculations.total.TotalPieceRateHours}</td></tr>);
		// wage adjustment amount (total)
		total.push(<tr key={"total-wage-adjustment"}><td>Wage adjustmant</td><td>+${calculations.total.WageAdjustmentAmount.moneyFormat()}</td></tr>);

		// hours that aren't raspberry pruning hours (regular hours)
		total.push(<tr key={"total-regular-hours"}><td>Regular hours</td><td>{calculations.total.RegularHours} (${calculations.total.RegularDollars.moneyFormat()})</td></tr>);
		total.push(<tr key={"total-overtime-hours"}><td>Overtime hours</td><td>{calculations.total.OvertimeHours} (${calculations.total.OvertimeDollars.moneyFormat()})</td></tr>);
		total.push(<tr key={"total-sick-hours"}><td>Sick hours</td><td>{calculations.total.SickHours} (${calculations.total.SickDollars.moneyFormat()})</td></tr>);

		output = [output, <table className="totals sheet" key="totals"><tbody>{total}</tbody></table>];
		return output;
	}
	
	return <>
		<Box title={props.Employee.FirstName + " " + props.Employee.LastName} className="payroll-summary">
			<Table columns={columns} data={props.payperiods[0].tasks} onClick={editOne}/>
			<Box modal={true} isOpen={interfaceOpen} onRequestClose={closeInterface} title="Modify attendance record">
				<ModifyForm data={selected} onUpdated={onUpdated} />
			</Box>
			{ breakdown() }
		</Box>
	</>
}